import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { TopBar } from 'sm-react-components';
import mixpanel from '../../infrastructure/mixpanel';
import { getStorage, removeStorage } from '../../infrastructure/storageService';
import * as routes from '../../infrastructure/routemap';
import { SessionConsumer } from './SessionProvider';


const styles = theme => ({});

class Header extends Component {
    state = {
        redirect: undefined,
        asUser: null
    };

    redirect = (route) => {
        this.setState({ redirect: route });
    }

    componentDidMount = () => {
        this.setState({
            asUser: getStorage('as_user')
        });
    }


    handleCloseAsUser = () => {
        removeStorage('as_user');
        removeStorage('requestSelected');
        window.location.replace('/console/users');
    }

    render() {
        const { tab, sections, ...other } = this.props;
        const { asUser, redirect } = this.state;
        const userActions = [
            {
                name: 'logout',
                label: 'Log out',
                actionHandler: () => this.redirect(routes.logout),
            },
            ...asUser ? [{
                name: 'backroot',
                label: 'Back to root',
                actionHandler: this.handleCloseAsUser,
            }] : []
        ];

        return (
            <SessionConsumer>
                {({ user, ready, loggedIn, logout }) =>
                    <React.Fragment>
                        {redirect !== undefined && <Redirect to={redirect} />}
                        <TopBar
                            title='Flake'
                            titleClickAction={() => this.redirect(routes.root)}
                            isLogged={loggedIn}
                            userActions={userActions}
                            buttonActions={[...!loggedIn ? [
                                {
                                    name: 'login',
                                    label: 'Login',
                                    actionHandler: () => this.redirect(routes.login),
                                }
                            ] : []]}
                            tabActions={sections}
                            userInfo={user}
                            currentTab={tab}
                            mixpanel={mixpanel}
                            asUser={asUser ? this.handleCloseAsUser : undefined}
                            {...other}

                        />
                    </React.Fragment>
                }
            </SessionConsumer>
        );
    }
}

export default withStyles(styles)(Header);